<template>
  <div class="black-back">

             <van-notice-bar style="z-index: 10000;" v-if="scoreStatus=='add'" text="   裁判长提醒您，打分偏差过大，请向上调分。"/>
             <van-notice-bar style="z-index: 10000;" v-if="scoreStatus=='pen'" text="   裁判长提醒您，打分偏差过大，请向下调分。"/>
    <div class="score-head">
      <div class="score-logo">
        <div class="score-logo-box">
<!--          <img src="https://static.dierqudao.com/images/cca/login-logo.png" alt="">-->
          <img src="../../../assets/images/score/logo2.png" alt="">
        </div>
      </div>
      <div class="score-title">{{ row.saiqu_name }} {{ row.title }}</div>
      <div class="score-title-child">{{ row.subject.subject_name }}</div>
      <div class="score-title-child" @click="peopleShow = true">{{ row.subject.mingcheng }}</div>
    </div>

    <div class="score-content">
      <div class="score-content-left">
        <div class="score-value-box">
          <div class="score-value-text flex-between">
            <div class="flex-start">
              <div class="score-value-label"></div>
              <div class="score-value-li">分值</div>
            </div>
            <div class="flex-start" style="font-size: 18px;cursor: pointer" @click="onRefresh">
              <van-icon name="replay"/>  
              <div style="margin-left: 2px">刷新</div>
            </div>
          </div>
          <div class="score-value-content flex-center">{{ formData.score > 0 ? formData.score : '--' }}
<van-icon name="play" v-if="scoreStatus=='pen'" style="transform: rotate(90deg);"  color="#0dac0d" />  
<van-icon v-if="scoreStatus=='add'" name="play"  style="transform: rotate(-90deg);"  color="#ff0000" />  
          </div>
          <div class="score-comment-box">
            <div class="score-comment-head flex-between">
              <div class="score-comment-head-left flex-start">
                <div class="score-value-label"></div>
                <div class="score-value-li">评语</div>
              </div>
              <div class="score-comment-head-right" @click="onComment">
<!--                <img src="https://static.dierqudao.com/images/cca/comment-edit.png" alt="">-->
                <img src="../../../assets/images/score/comment-edit.png" alt="">
              </div>
            </div>
            <div class="score-comment-text">
              <!-- {{ formData.content }} -->
              <!-- {{commentResult}} --> 
              <van-tag style="margin:0 10px 10px 0" @click="commentClose(cindex)" closeable @close="commentClose(cindex)"  :key="cindex" v-for="cvalue,cindex in commentResult">{{cvalue.name}}</van-tag>
              
            </div>
          </div>
        </div>
        <!--        <div @click="toReLogin" :class="reconnectShow ? 'score-caipan-box score-caipan-offline' : 'score-caipan-box score-caipan-online' ">-->
        <div class="score-caipan-box score-caipan-online">
          <div class="score-caipan-value flex-between">
            <div class="score-caipan-left flex-start">
              <div class="caipan-button" style="padding: 5px 10px 5px 0;" @click="toLoginOutAuto">退出</div>
              <div class="caipan-name"> {{
                  row.caipan.jgroup == 1 ? 'B组裁判' + '-' + (row.caipan.index + 1) + '-' + row.caipan.name :
                      'A组裁判' + '-' + (row.caipan.index + 1) + '-' + row.caipan.name
                }}
              </div>
            </div>
            <!--            <div class="score-caipan-right">{ reconnectShow ? '重新联网' : '网络正常' }}</div>-->
            <div class="score-caipan-right">网络正常</div>
          </div>
        </div>
      </div>
      <div class="score-content-right flex-start">
        <div class="key-left">
          <div class="key-li" @click="onKey(1)">1</div>
          <div class="key-li" @click="onKey(2)">2</div>
          <div class="key-li" @click="onKey(3)">3</div>
          <div class="key-li" @click="onKey(4)">4</div>
          <div class="key-li" @click="onKey(5)">5</div>
          <div class="key-li" @click="onKey(6)">6</div>
          <div class="key-li" @click="onKey(7)">7</div>
          <div class="key-li" @click="onKey(8)">8</div>
          <div class="key-li" @click="onKey(9)">9</div>
          <div class="key-li-full" @click="onKey(0)">0</div>
          <div class="key-li" @click="onKey('.')">.</div>
        </div>
        <div class="key-right">
          <div class="key-delete flex-center" @click="onKey('delete')">
<!--            <img src="https://static.dierqudao.com/images/cca/score-delete.png" alt="">-->
            <img src="../../../assets/images/score/score-delete.png" alt="">
          </div>
          <div class="key-button flex-center" style="background: #1989FA;color: #fff;" @click="onSubmit"
               v-if="row.caipan.jgroup === row.subject.jgroup && !scoreCurrent || scoreStatus">提交
          </div>
          <div class="key-button flex-center" style="background: #44D7B6;color: #fff;cursor:not-allowed " v-else>完成
          </div>
        </div>
      </div>

    </div>

    <div style="color: #fff" v-if="false">
      <div>that.formData: || {{ formData }}</div>
      <div>row.caipan: || {{ row.caipan.jgroup }}</div>
      <div>row.subject: || {{ row.subject.jgroup }}</div>
      <div>scoreStatus: || {{ scoreStatus }}</div>
      <div>dataAll: || {{ dataAll }}</div>
      <div>scoreCurrent: || {{ scoreCurrent }}</div>
    </div>
    <!-- <van-dialog v-model="commentShow" title="添加评语">
      <van-field
          v-model="formData.content"
          clearable
          :closeOnClickOverlay="true"
          :autofocus="true"
          label="评语"
          @input="onCommentChange"
          placeholder="请输入评语"
      />
    </van-dialog> -->
    <van-popup v-model="peopleShow">
      <div class="people">
        <div class="people-title">运动员</div>
        <div class="people-content">{{ row.subject.yundongyuans }}</div>
      </div>
    </van-popup>


    <van-popup v-model="commentShow"   position="bottom" :style="{ height: '90%', right:0,width:'100%' }">
      <div class="comment-selector">  
        <van-cell-group>
        <van-field
          readonly
          is-link
          v-model="commentSubject"
          label="项目分类"
          placeholder="请选择项目分类"
          @click="showCommentSubjectPicker=true"
        />
      </van-cell-group>
        <van-tabs v-model="subSubjectValue" @change="subSubjectChange">
        <van-tab :title="tvalue" v-for="(tvalue,tindex) in subSubjectTabs" :key="tindex" />
      </van-tabs>
      <van-cell-group v-if="commentOptions.length>0">
              <van-cell
                v-for="(item, index) in commentOptions"
                clickable 
                :key="index"
                @click="commentToggle(item)" 
              >
                <template slot="title">
                  <div class="custom-title">{{item.name}}</div>
                </template>
                <van-checkbox
                  v-model="item.checked"
                  slot="right-icon"
                  checked-color="#FD2840"
                />
              </van-cell>
            </van-cell-group>

        
          <van-popup v-model="showCommentSubjectPicker" position="bottom">
              <van-picker   show-toolbar :columns="commentSubjectcolumns" @confirm="onCommentSubjectComfirm" />
          </van-popup>

          <van-button @click="commentShow=false;commentResult=[]" style="position:fixed;bottom:10px;right:400px">清除并取消</van-button>
          <van-button @click="commentShow=false;"   type="primary" style="position:fixed;bottom:10px;right:200px">我选好了</van-button>
      </div>
    </van-popup>
  </div>

</template>
<style scoped>
.comment-selector{
  width: 100%;
  height: 90%;
  background: #fff;
}
.black-back {
  background: rgb(0, 0, 0);
  min-height: 100vh;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.key-li:active, .key-li-full:active, .key-delete:active {
  background: #ebedf0;
}

.score-caipan-online {
  background: #1989FA;
}

.score-caipan-offline {
  background: #FA6400;
}

.people {
  padding: 0.2rem 0.3rem;
  border-radius: 0.2rem;
}

.people-title {
  padding: 0.2rem 0;
  font-size: 16px;
  font-weight: 700;
}

.people-content {
  padding: 0.2rem 0;
}

@media (max-width: 768px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.25rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.28rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .88rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin: 0.1rem 0 .1rem;
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    overflow-y: hidden;
    height: 1.2rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .2rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    width: 120%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.9rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .5rem;
  }

  .key-delete img {
    width: 0.5rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 1.5rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.1rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 3.1rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    padding: 0.1835rem;
  }

  .score-content-right {
    /*width: 4.1367rem;*/
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 4rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    height: 3rem;
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
  }

  .score-caipan-box {
    height: 0.5rem;
    border-radius: 0.5rem;
    color: #fff;
    font-weight: 500;
    font-size: .18rem;
    margin: .15rem 0;
  }

  .score-caipan-value {
    margin: 0 32px 0 22px;
    height: 100%;
  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1.6rem;
    height: 1.6rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .15rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
  }

  .score-logo-box img {
    min-width: 0.5rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.2rem;
    padding: .2rem 0;
  }

  .score-title-child {
    font-size: .18rem;
    /*padding: 19px 0;*/
  }
}

@media screen and  (min-width: 768px) and (max-width: 1199px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.1562rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.1875rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .7812rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin: 0.2656rem 0 .1562rem;
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    height: .7812rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .1132rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    width: 85%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.2537rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .16rem;
  }

  .key-delete img {
    width: 0.3482rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 0.9257rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 1.9529rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    padding: 0.1835rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .score-content-right {
    width: 4.1367rem;
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 3rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    width: 2.9179rem;
    height: 2.5664rem;
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
    margin: 0 .07rem .07rem 0;
  }

  .score-caipan-box {
    width: 2.9179rem;
    height: 0.375rem;
    border-radius: 0.375rem;
    /*padding: 0 32px 0 44px;*/
    color: #fff;
    font-weight: 500;
    font-size: .1093rem;
  }

  .score-caipan-value {
    margin: 0 32px 0 44px;
    height: 100%;

  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1rem;
    height: 1rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .1rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
  }

  .score-logo-box img {
    width: 0.4rem;
    min-width: 0.4rem;
    height: 0.4rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.2rem;
    padding: .1rem 0;
  }

  .score-title-child {
    font-size: .15rem;
    /*padding: 19px 0;*/
  }
}

@media screen and (min-width: 1200px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.1562rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.1875rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .7812rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin: 0.2656rem 0 .1562rem;
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    height: .7812rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .1132rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    /*width: 0.9257rem;*/
    width: 85%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.2537rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .16rem;
  }

  .key-delete img {
    width: 0.3482rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 0.9257rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 1.9529rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.1835rem;
  }

  .score-content-right {
    width: 4.1367rem;
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 3rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    width: 2.9179rem;
    height: 2.5664rem;
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
    margin: 0 .07rem .07rem 0;
  }

  .score-caipan-box {
    width: 2.9179rem;
    height: 0.375rem;
    border-radius: 0.375rem;
    color: #fff;
    font-weight: 500;
    font-size: .1093rem;
  }

  .score-caipan-value {
    margin: 0 32px 0 44px;
    height: 100%;

  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% .8rem;
    height: .8rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .078rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
  }

  .score-logo-box img {
    width: 0.234rem;
    min-width: 0.234rem;
    height: 0.234rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.15625rem;
    padding: .074rem 0;
  }

  .score-title-child {
    font-size: .117rem;
    /*padding: 19px 0;*/
  }

  .van-tag{
    font-size: 16px;
  }
}

</style>
<script>
import Vue from 'vue';
import NumKeypad from '@/components/NumKeypad.vue';
import {
  Cell,
  Icon,
  Field,
  Tag,
  Popup,
  Stepper,
  Toast,
  Dialog,
  Button,  
  Picker,
} from 'vant';

export default {
  name: 'CommonScore',
  components: {

    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Stepper.name]: Stepper,
    [Picker.name]: Picker,
    NumKeypad
  },
  data: function () {
    return {
      commentShow: false,
      saveLoading: false,
      isLoading: false,
      showCommentSubjectPicker:false,
      commentResult:[],
      commentSubject:'',
      commentOptionsTree:[],
      commentOptions:[
        // {
        //   name:'选项1',
        //   checked:false,
        // }, 
      ],
      peopleShow: false,
      row: {
        current_index: 0,
        caipan: {jgroup: 0},
        subject: {subject_name: '', jgroup: 0}
      },
      commentSubjectcolumns:[
        // '项目1','项目2','项目3'
      ],
      subSubjectTabs:[
        // '花球','托举','爵士'
      ],
      selectTopIndex:0,
      selectSubIndex:0,
      subSubjectValue:0,
      selectComments:'',
      id: 0,
      start_id: 0, //场次id
      heartTime: 0, //超过14s 显示重连
      reconnectShow: false,
      scoreStatus: '',
      commentContent: '',
      scoreCurrent: 0,
      commentList: [],
      formData: {
        id: 0,
        score_index: 0,
        score: '',
        content: '',
      },
      dataAll: [],

      timer: null
    }
  },
  filters: {},
  mounted() {
    let that = this;
    // that.init()
    document.title="打分"
    // 换成轮询
    that.fetch();
    that.timer = setInterval(function () {
      that.onRefresh();
    }, 4000)

    // that.getCommentList();
  },
  watch: {}, 
  destroyed() {
    // 销毁监听
    // this.clearAll()
    // this.socket.close()

    this.onLoginOut()
    clearInterval(this.timer)
    localStorage.removeItem('_score')
    localStorage.removeItem('_content')

    // 裁判注销
    // that.onLoginOut()
  },
  methods: {
    onCommentSubjectComfirm(val,index){
      console.log('onCommentSubjectComfirm',val,index)
      this.commentSubject = val
      this.showCommentSubjectPicker = false
      this.subSubjectValue = 0
      this.freshCommentOptions()
    }, 
    commentToggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中 
          //多选 

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        if( this.commentResult.filter(val =>{
          return val.name == item.name
        }).length==0){
          this.commentResult.push(item);
        }

      }else{
        //pen
        this.commentResult = this.commentResult.filter(val =>{
          return val.name != item.name
        });
      }
    },
    commentClose(index){
      this.commentResult.splice(index,1)
    },
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/subjectDetail', {
        num: localStorage.getItem('_id_num')
      }, (res) => {
        let row = that.row = res.data.row;
        that.isLoading = false;

        let score = that.scoreCurrent = parseFloat(row.subject['score' + (row.caipan.index + 1)]).toFixed(1)
        if(score==0){
          score = that.scoreCurrent = 0
        }
        let content = that.commentContent = row.subject['comment' + (row.caipan.index + 1)]

        if(row.subject['score_fix_' + (row.caipan.index + 1)]){
          that.scoreStatus = row.subject['score_fix_' + (row.caipan.index + 1)]
        }

        //场次信息 场次的id 当前裁判的index ，num

        that.formData.score = score ? score : ''
        that.formData.content = content ? content : ''
        that.formData.score_index = row.caipan.index + 1
        that.formData.id = row.subject.id

        that.start_id = res.data.row.id
        that.onStatusChange(1)

        // 存在 row.subject.jgroup不存在的情况
        row.subject.jgroup = row.subject.jgroup ? row.subject.jgroup : 0

        if (row.caipan.jgroup != row.subject.jgroup) {
          Toast('不属于当前组别裁判')
        }

        // 发送心跳超过 40s 显示重连按钮
        that.heartReconnectTimer = setInterval(function () {
          that.heartTime += 1
          // console.log('that.heartTime', that.heartTime)
          if (that.heartTime > 40) {
            that.reconnectShow = true
          }
        }, 1000)
      }, (res) => {
        Toast(res.msg)
      }, 2)
    },

    // 评论输入
    onComment() {
      this.commentShow = true 
      this.getCommentOptions()
    },

    onCommentChange(value) {
      console.log('onCommentChange', value)
      localStorage.setItem('_content', value)
    },

    // 键盘输入
    onKey(value) {
      /**
       * 1. 不能有两个小数点
       * 2. 小数不能为 5
       * 3. 值需要是1-100 以内的值
       */
      let score = this.formData.score+''
      // 打分完成 禁止输入
      if (this.scoreCurrent && !this.scoreStatus) return


      console.log(value, score, score.length)

      if (value == 'delete' && score.length > 0) {
        // 删除
        score = score.substring(0, score.length - 1);
        this.formData.score = score
        return;
      }

      if (value === 'delete') return
      if ((!score || score.indexOf('.') > -1) && value === '.') {
        return
      }
      if (!score && value === 0) return

      if (score.indexOf('.') > -1 && value != 5) {
        score = score.substring(0, score.length - 1);
        this.formData.score = score
        Toast('小数值只能为5');
        return
      }

      score = score + value

      if (score > 100) {
        Toast('分值不能大于100哦');
        return
      }

      // 缓存score值
      localStorage.setItem('_score', score)


      this.formData.score = score
    },
 
    onRefresh() {
      let that = this
      that.$api.post('/api/dscore/subjectDetail', {
        num: localStorage.getItem('_id_num')
      }, (res) => {
        let row = that.row = res.data.row;
        that.isLoading = false;

        let score = that.scoreCurrent = parseFloat(row.subject['score' + (row.caipan.index + 1)]).toFixed(1)
        if(score==0){
          score = that.scoreCurrent = 0
        }
        let content = that.commentContent = row.subject['comment' + (row.caipan.index + 1)]

        if(row.subject['score_fix_' + (row.caipan.index + 1)]){
          that.scoreStatus = row.subject['score_fix_' + (row.caipan.index + 1)]
          return ;
        }

        // 判断是否有缓存的分值和评论文字
        if (!score) {
          let scoreOld = localStorage.getItem('_score')
          let contentOld = localStorage.getItem('_content')
          if (scoreOld) score = scoreOld
          if (contentOld) content = contentOld
        }

        that.formData.score = score ? score : ''
        that.formData.content = content ? content : ''
        that.formData.score_index = row.caipan.index + 1
        that.formData.id = row.subject.id

        that.start_id = res.data.row.id
        // that.onStatusChange(1)

        row.subject.jgroup = row.subject.jgroup ? row.subject.jgroup : 0

        if (row.caipan.jgroup != row.subject.jgroup) {
          Toast('不属于当前组别裁判')
        }

        // if (that.socket.readyState === 3 || that.reconnectShow) {
        //   that.init()
        // } else {
        //   //do something
        // }

        if (row.caipan.status == 2) {
          // 下线
          rbLink({
            name: 'CommonLogin'
          }, 'back');
          // localStorage.removeItem('_id_num')
          that.clearAll()

        }

      }, (res) => {
        Toast(res.msg)
      }, 2)
    },

    onSelectComment(data) {
      this.formData.content = data.content
    },
    subSubjectChange(value){
      console.log('subSubjectChange',value)
      this.freshCommentOptions()
    },
    getCommentOptions(){
      let that = this;
      that.$api.post('/api/dscore/getSubjectOptions', {
        subject_name:this.row.subject.subject_name,
        saiqu:this.row.subject.saiqu,
        subject:this.row.subject.subject,
      }, (res) => {  
        console.log("getCommentOptions",res)
        this.commentSubjectcolumns = res.data.list.map(tvalue=>{
          return tvalue.content
        })
        // this.commentSubject = this.commentSubjectcolumns[0]
        this.commentSubject = this.commentSubjectcolumns[res.data.topindex]
        that.commentOptionsTree = res.data.list
        that.selectTopIndex = 0;
        that.selectSubIndex = 0;
        that.freshCommentOptions();
      }, (res) => {
          Toast(res.msg)
      })
    },
    freshCommentOptions(){
      let that = this;
      let selectTopIndex = this.commentSubjectcolumns.indexOf(this.commentSubject)
      this.subSubjectTabs = this.commentOptionsTree[selectTopIndex].list.map(tvalue=>{
        return tvalue.name
      })  
      this.commentOptions = this.commentOptionsTree[selectTopIndex].list[this.subSubjectValue].list.map(tvalue=>{
        
        let checked = that.commentResult.filter(ffitem=>{
          return ffitem.name == tvalue
        }).length>0
        console.log('checked',checked)

        return {
          name:tvalue,
          checked:checked
        }
      })
    },
    onStatusChange(status) {
      let that = this,
          num = localStorage.getItem('_id_num')

      that.$api.post('/api/dscore/caipanStatusChange', {
        id: that.start_id,
        num: num,
        status: status
      }, (res) => {
        // 裁判登录成功
        let data = {
          'id': that.start_id
        }

        // let val = that.formatSocketInfo('caipan_login', num, data)
        // that.socket.send(val);
      }, (res) => {
        Toast(res.msg)
      }, 2)
    },

    onSubmit() {
      let that = this
      if (!that.formData.score) {
        Toast('请输入分值')
        return
      }
      that.formData.content = that.commentResult.map(citem =>{
        return citem.name
      }).join("\n");
      Dialog.confirm({
        title: '评分',
        message: '确认评分吗',
      })
          .then(() => {
            // on confirm
            that.$api.post('/api/dscore/scoreSave', that.formData, (res) => {
              // 通知服务端
              // 提交分数成功
              let data = {
                'id': that.start_id
              }

              localStorage.removeItem('_score')
              localStorage.removeItem('_content')
              // let val = that.formatSocketInfo('score_submit', localStorage.getItem('_id_num'), data)
              // that.socket.send(val);

              that.scoreStatus = ''
              that.scoreCurrent = that.formData.score
              that.commentContent = that.formData.content
              Toast.success('打分成功')
            }, (res) => {
              if (res.code == 401 || res.code == 402) {
                if (window.isApp()) {
                  rbLink({
                    name: 'login', 'query': {}
                  }, 'replace');
                  return false;
                }
                that.loginShow = true
              } else {
                Toast(res.msg)
              }
            }, 2)

            that.saveLoading = true
          })
          .catch(() => {
            // on cancel
          });

    },

    // 重连
    toReLogin() {
      let that = this
      console.log('that.socket.readyState', that.socket.readyState)
      if (that.socket.readyState === 3 || that.reconnectShow) {
        that.heartTime = 0
        that.reconnectShow = false

        that.clearAll()

        that.fetch();
        that.init()
      } else {
        //do something
      }
    },


    toLoginOutAuto() {
      Dialog.confirm({
        title: '退出登陆',
        message: '您确认退出登陆吗',
      })
          .then(() => {
            // on confirm
            this.onLoginOut()
          })
          .catch(() => {
            // on cancel
          });
    },

    // 自动退出
    onLoginOutAuto() {
      let that = this
      that.$api.post('/api/dscore/caipanStatusChange', {
        id: that.start_id,
        num: localStorage.getItem('_id_num')
      }, res => {
        // 发送注销指令 caipan_logout
        let val = JSON.stringify({
          'type': 'caipan_logout_auto',
          'token': localStorage.getItem('_id_num'),
          'id': that.start_id,
          'user': 'common'
        })

        // that.socket.send(val);

        setTimeout(function () {
          rbLink({
            name: 'CommonLogin'
          }, 'back');
          localStorage.removeItem('_id_num')
          that.clearAll()
          // that.socket.close()
        }, 10)
      }, res => {

      }, 2)
    },

    // 裁判注销
    onLoginOut() {
      let that = this,
          num = localStorage.getItem('_id_num')
      // 更改服务端 裁判状态
      that.$api.post('/api/dscore/caipanStatusChange', {
        id: that.start_id,
        num: num
      }, res => {

        // 裁判注销成功
        let data = {
          'id': that.start_id
        }

        rbLink({
          name: 'CommonLogin'
        }, 'back');

        that.clearAll()


        // 移除套接字 资源
        // let val = that.formatSocketInfo('caipan_logout', num, data)
        // that.socket.send(val);
      }, res => {
      }, 2)
    },

    // 单点登录
    onLoginOutOne() {
      rbLink({
        name: 'CommonLogin'
      }, 'back');
      // localStorage.removeItem('_id_num')
      this.clearAll()
      this.socket.close()
    },

    clearAll() {
      let that = this
      clearTimeout(that.timer)
      // clearInterval(that.heartTimer)
      // clearInterval(that.heartReconnectTimer)
    },

    init: function () {
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        let that = this
        // this.socket = new WebSocket(`ws://sjzh2019.ticp.io:8888/dev/websocket/${this.userId}`);
        this.socket = new WebSocket(wsRoot);
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose = this.close

        this.socket.onclose = function (e) {
          // that.reconnect()
          console.log('websocket 断开：' + e.code + ' ' + e.reason + ' ' + e.wasClean)
          console.log(e)
          that.reconnectShow = true
        }
      }
    },
    open: function () {
      console.log("socket连接成功")
      this.heartStart();
      this.heartCheck();
    },
    error: function () {
      console.log("连接错误")
      // this.reconnect()
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data),
          that = this,
          num = localStorage.getItem('_id_num')

      console.log('getMessage', data.type, data.token, num)
      if (data.type != 'caipan_logout') {
        this.dataAll.push(data)
      }

      switch (data.type) {
        case 'score_reset':
          // 重新打分 已打分后，只有裁判长发送重打命令 才可以重新打分
          if ((data.token + '').toLowerCase() == (num + '').toLowerCase()) {
            that.scoreStatus = 'reset_score'
            that.scoreCurrent = that.formData.score = ''
          }
          break;
        case 'caipan_logout':
          //裁判退出
          if ((data.token + '').toLowerCase() == (num + '').toLowerCase()) {
            rbLink({
              name: 'CommonLogin'
            }, 'back');
            // localStorage.removeItem('_id_num')
            this.clearAll()
            this.socket.close()
          }
          break;
        case 'sai_start':
          // 开始比赛
          // 实时刷新 页面
          if (data.data.id == that.start_id) {
            this.onRefresh()
          }
          break;
        case 'caipan_logout_one':
          // 单点登录
          this.onLoginOutOne()
          break;
        case 'heart_check_success':
          // 心跳检测
          // console.log('heart_check_success')
          // 接收到服务端返回 将检测心跳的时间置为0
          that.heartTime = 0
          that.reconnectShow = false
          break;
        case 'heart_check':
          // 心跳检测
          let token = num,
              value = {
                'id': that.start_id
              }

          let val = that.formatSocketInfo('heart_check', token, value)
          that.socket.send(val);
          break;
      }
    },
    send: function (params) {
      this.socket.send(params)
    },
    close: function () {
      console.log("socket已经关闭")
    },

    heartStart() {
      let that = this;

      let token = localStorage.getItem('_id_num'),
          data = {
            'type': 'common'
          }

      let val = that.formatSocketInfo('heart_start', token, data)
      that.socket.send(val)
    },

    heartCheck() {
      let that = this;
      that.heartTimer = setInterval(function () {
        let token = localStorage.getItem('_id_num'),
            data = {
              'id': that.start_id
            }

        let val = that.formatSocketInfo('heart_check', token, data)
        that.socket.send(val)

      }, 8000);
    },

    formatSocketInfo(type, token, data) {
      return JSON.stringify({
        'type': type,
        'token': token,
        'data': data,
      })
    },

    reconnect() {
      let that = this,
          lockReconnect = that.lockReconnect,
          tt = that.timer

      // 重连
      if (lockReconnect) return
      lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt)
      that.timer = setTimeout(function () {
        that.init()
        lockReconnect = false
      }, 4000)

    },
  }
}
</script>



// WEBPACK FOOTER //
// CommonScore.vue?04646f5d